import { render, staticRenderFns } from "./CloseBox.vue?vue&type=template&id=2ec97b7e&scoped=true&"
import script from "./CloseBox.vue?vue&type=script&lang=js&"
export * from "./CloseBox.vue?vue&type=script&lang=js&"
import style0 from "./CloseBox.vue?vue&type=style&index=0&id=2ec97b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.12_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec97b7e",
  null
  
)

export default component.exports